import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { IBook } from 'app/data/books/types';
// import { Logger } from 'src/app/services/logger.service';
import { MediaObserver } from '@angular/flex-layout';
import { DiscountService } from 'src/app/services/discount.service';
import { getBooksDiscount } from 'src/app/services/discount.service/discount.functions';
import { EBookPointType, TBookPoints } from 'app/data/books/points/types';
import { ROUTE_PATH_GIFT_BUY } from 'app/app-routing.constants';
import { scrollToSelector } from 'app/functions';

// const log = new Logger('Preview -> SectionDetailsComponent');

const giftHref = `${location.origin}/${ROUTE_PATH_GIFT_BUY}`;

@Component({
  selector: 'app-section-details',
  templateUrl: './section-details.component.html',
  styleUrls: ['./section-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionDetailsComponent {
  @Input() book!: IBook;

  public readonly getBooksDiscount = getBooksDiscount;

  public readonly customPoints: TBookPoints = [{
    caption: '手軽に絵本を贈りたい（ギフトコード）',
    description: `ギフトコード（お仕立券）をご利用いただけます。詳しくは<a href="${giftHref}">こちら</a>`,
    type: EBookPointType.additional,
  }]

  constructor(
    public media: MediaObserver,
    public discountService: DiscountService,
  ) { }

  onNoticeButtonClick() {
    scrollToSelector('app-section-banner-mermaid');
  }
}
